interface Props {
  className?: string;
}

export default function CheckSuccess({className}: Props) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="56"
      height="56"
      viewBox="0 0 56 56">
      <defs>
        <path id="b" d="M21 14h14v23H21z" />
        <filter
          id="a"
          width="135.7%"
          height="121.7%"
          x="-17.9%"
          y="-10.9%"
          filterUnits="objectBoundingBox">
          <feOffset
            dx="-5"
            dy="-5"
            in="SourceAlpha"
            result="shadowOffsetInner1"
          />
          <feComposite
            in="shadowOffsetInner1"
            in2="SourceAlpha"
            k2="-1"
            k3="1"
            operator="arithmetic"
            result="shadowInnerInner1"
          />
          <feColorMatrix
            in="shadowInnerInner1"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd">
        <circle cx="28" cy="28" r="28" fill="#5AC864" fillOpacity=".4" />
        <use
          fill="#000"
          filter="url(#a)"
          transform="rotate(45 28 25.5)"
          xlinkHref="#b"
        />
      </g>
    </svg>
  );
}
